import store from '@/store'

/**
 * Filter the data required by the delivery system
 * @param {Object} data Interface returned data
 * @param {String} url API interface path
 * @returns
 */
/**
 * 过滤外卖系统所需要的数据
 * @param {Object} data 接口返回数据
 * @param {String} url API 接口路径
 * @returns
 */
function _filterOnlineData(data, url) {
  let newData = JSON.parse(JSON.stringify(data))
  if (url === '/customer/default/get-product') newData = _setPrice(data)
  if (url === '/customer/default/get-product-list') {
    // If the product data has not changed, the interface data will not return the productGroup. You need to retrieve the product information in vuex
    // 如果商品数据没有变动，则接口数据中不会返回 productGroup，需要取 vuex 中的商品信息
    let productGroups = data.productGroup
    if (!productGroups) productGroups = store.state.venueHome.venueHomeProductInfo
    if (productGroups?.length) {
      newData.productGroup = productGroups.map(productGroup => ({
        ...productGroup,
        products: productGroup.products.map(product => _setPrice(product))
      }))
    }
  }
  return newData
}

/**
 * Assign the product price as the delivery price
 * @param {Object} product Commodity data
 * @returns {Object} Final commodity data
 */
/**
 * 给商品价格赋值成外卖价格
 * @param {Object} product 商品数据
 * @returns {Object} 最终的商品数据
 */
function _setPrice(product) {
  const newProduct = {
    ...product,
    price: _hasOnlinePrice(product)
  }

  // Operate size list
  // 操作 size 列表
  if (newProduct.sizeSettings?.settings?.length) {
    newProduct.sizeSettings.settings = newProduct.sizeSettings.settings.map(item => ({
      ...item,
      price: _hasOnlinePrice(item)
    }))
  }

  // Operate list of recommendations
  // 操作推荐菜列表
  if (newProduct.recommendationProducts?.length) {
    newProduct.recommendationProducts = product.recommendationProducts.map(recommendation => ({
      ...recommendation,
      items: recommendation.items.map(item => ({
        ...item,
        price: _hasOnlinePrice(item)
      }))
    }))
  }
  return newProduct
}

/**
 * Whether there is onlinePrice in the product data
 * @param {Object} data Product data to check
 * @returns Result of condition check
 */
/**
 * 是否商品数据中拥有 onlinePrice
 * @param {Object} data 要检查的商品数据
 * @returns 条件检查的结果
 */
function _hasOnlinePrice(data) {
  return ((data?.onlinePrice || data.onlinePrice === 0) && (typeof data.onlinePrice === 'string' ? data.onlinePrice : typeof data.onlinePrice === 'number')) ? data.onlinePrice : data.price
}

export {
  _filterOnlineData
}